var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "collection-hero" }, [
      _vm.defaultSettings.imageUrl
        ? _c("div", { staticClass: "collection-hero__with-image" }, [
            _c("div", { staticClass: "collection-hero__text" }, [
              _c("h1", { class: [_vm.$mq !== "mobile" ? "h2" : "h3"] }, [
                _vm._v(_vm._s(_vm.heroTitle))
              ]),
              _c("div", {
                staticClass: "description-field body-md",
                domProps: { innerHTML: _vm._s(_vm.heroDescription) }
              })
            ]),
            _c(
              "div",
              { staticClass: "collection-hero__with-image-image__wrapper" },
              [
                _c("picture", [
                  _c("source", {
                    attrs: {
                      media: "(min-width: '768px')",
                      srcset: _vm.defaultSettings.imageUrl
                    }
                  }),
                  _c("img", {
                    staticClass: "collection-hero__with-image-image",
                    attrs: {
                      src: _vm.defaultSettings.imageUrlMobile,
                      loading: "lazy"
                    }
                  })
                ])
              ]
            )
          ])
        : _c("div", { staticClass: "collection-hero__no-image" }, [
            _c("div", { staticClass: "collection-hero__text" }, [
              _c("h1", { class: [_vm.$mq !== "mobile" ? "h2" : "h3"] }, [
                _vm._v(_vm._s(_vm.heroTitle))
              ]),
              _c("div", {
                staticClass: "description-field body-md",
                domProps: { innerHTML: _vm._s(_vm.heroDescription) }
              })
            ])
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }